class MHProductRecommendations extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    var url = this.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then((text) => {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(function (e) { console.warn('MH recommendations fetch failed', e); });
  }
}
customElements.define('product-recommendations', MHProductRecommendations);
